import { z } from 'zod';
import { CSAT_SCORES } from '../csat.js';
import { text } from './common.js';
export const DUPLICATE_WINDOW_MINUTES = 30;
export const visitCreateSchema = z.object({
    technicianId: z.number().int().positive(),
    facilityId: z.number().int().positive(),
    /** UTC instant; the web converts Los Angeles wall time with toUtc() before sending. */
    scheduledAt: z.string().datetime({ offset: true }),
    durationMinutes: z.number().int().min(15).max(720).optional(),
    scopeOfWork: text(5, 2000),
    additionalTasks: text(0, 2000).nullable().optional(),
    /** Manager+ only: create directly as Scheduled. */
    approveNow: z.boolean().optional(),
    /** Manager+ only: allow a scheduled time in the past (corrections). */
    allowPast: z.boolean().optional(),
    /** Acknowledge a DUPLICATE_SUSPECTED warning and create anyway. */
    confirmDuplicate: z.boolean().optional(),
});
export const visitEditSchema = z
    .object({
    technicianId: z.number().int().positive(),
    scheduledAt: z.string().datetime({ offset: true }),
    durationMinutes: z.number().int().min(15).max(720),
    scopeOfWork: text(5, 2000),
    additionalTasks: text(0, 2000).nullable(),
    allowPast: z.boolean(),
})
    .partial();
export const visitCheckoutSchema = z.object({ engineerNotes: text(10, 4000) });
export const visitSignSchema = z.object({
    csat: z.enum(CSAT_SCORES),
    adminNotes: text(0, 4000).nullable().optional(),
});
export const reasonSchema = z.object({ reason: text(3, 500) });
export const visitRescheduleSchema = visitCreateSchema.pick({
    technicianId: true,
    scheduledAt: true,
    durationMinutes: true,
    scopeOfWork: true,
    additionalTasks: true,
    allowPast: true,
});
export const hardDeleteSchema = z.object({
    reason: text(3, 500),
    confirm: z.literal('DELETE'),
});
//# sourceMappingURL=visit-actions.js.map